import { useState, useEffect } from 'react';
import { decorationRepository } from '../../../domain/decorationsRepository';


export const useDecorationPost = (isFormLoading, formData) => {
    const [decorationPostResult, setDecorationPostResult] = useState([]);

    useEffect(() => {
        if (isFormLoading && formData) {
            console.log(`useDecorationPost formData.image.name: ${formData.get('image').name}`)
            console.log(`useDecorationPost formData.lv1: ${formData.get('lv1')}`)
            decorationRepository.postDecoration(formData)
            .then((result) => {
                setDecorationPostResult(result)
            })
            .catch((err) => {
                console.error("Failed to fetch decoration types:", err)
            });
        }
    }, [isFormLoading, formData]);

    return decorationPostResult;
};